module.exports = __webpack_public_path__ + "static/img/6.789c365.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/zh/6.png
// module id = +QhO
// module chunks = 0